var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidGreenRound2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#95CF00",
    height: "48px",
    width: "48px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    stroke: "#95CF00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(61.44,61.44), scale(0.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 307.2,
    fill: "#FFFFFF",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.4,165.2c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4C237.8,168.5,234.5,165.2,230.4,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,165.2c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4C297.3,168.5,294,165.2,289.8,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M180.8,288.2c0,8.2-6.7,14.9-14.9,14.9 c-8.2,0-14.9-6.7-14.9-14.9v-63.6c0-8.2,6.7-14.9,14.9-14.9c8.2,0,14.9,6.7,14.9,14.9V288.2z M329.5,222.1v10.1v86.6 c0,8.7-7,15.7-15.7,15.7h-11.3c0.4,1.3,0.6,2.7,0.6,4.1v0.8v5V370c0,8.2-6.7,14.9-14.9,14.9s-14.9-6.7-14.9-14.9v-25.6v-5v-0.8 c0-1.4,0.2-2.8,0.6-4.1h-27.6c0.4,1.3,0.6,2.7,0.6,4.1v0.8v5V370c0,8.2-6.7,14.9-14.9,14.9s-14.9-6.7-14.9-14.9v-25.6v-5v-0.8 c0-1.4,0.2-2.8,0.6-4.1h-11.3c-8.7,0-15.7-7-15.7-15.7v-86.6v-10.1v-12.4h1.1h136.6h1.1L329.5,222.1L329.5,222.1z M190.7,199.9 c0-21.2,14.2-39.8,35.3-49.6l-2.8-4.2l-2.8-4.1l-6.2-9.3c-0.7-1.1-0.4-2.7,0.7-3.4c1.1-0.8,2.7-0.4,3.4,0.7l6.6,9.9l2.8,4.2 l2.8,4.2c9-3.5,18.9-5.4,29.5-5.4c10.5,0,20.5,1.9,29.5,5.4l2.8-4.2l2.8-4.2l6.6-9.9c0.7-1.1,2.3-1.5,3.4-0.7s1.5,2.3,0.7,3.4 l-6.2,9.3l-2.6,4.1l-2.8,4.2c21,9.8,35.2,28.3,35.2,49.6L190.7,199.9L190.7,199.9z M369.1,288.2c0,8.2-6.7,14.9-14.9,14.9 c-8.2,0-14.9-6.7-14.9-14.9v-63.6c0-8.2,6.7-14.9,14.9-14.9c8.2,0,14.9,6.7,14.9,14.9V288.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidGreenRound2);
export default __webpack_public_path__ + "static/media/android-green-round-2.cce2112f4120c3c564a41e5a8f6990e0.svg";
export { ForwardRef as ReactComponent };